import { request } from "@api/request";

export interface TenantSettings {
    language: string;
    currency: string;
    theme: "light" | "dark";
    emailNotifications: boolean;
    pushNotifications: boolean;
    /** Stored only — the server sends no reminders or reports yet. */
    shiftReminders: boolean;
    weeklyReports: boolean;
    lowStockThreshold: number;
    companyName: string | null;
    companyLogo: string | null;
    /** Minutes from UTC (-720…840). */
    timezoneOffset: number;
}

export interface SettingsResponse {
    message?: string;
    settings: TenantSettings;
}

export type SettingsPatch = Partial<
    Pick<
        TenantSettings,
        | "language"
        | "currency"
        | "theme"
        | "emailNotifications"
        | "pushNotifications"
        | "lowStockThreshold"
        | "companyName"
        | "timezoneOffset"
    >
>;

export const settingsApi = {
    get: () => request.get<SettingsResponse>("/tenant/settings"),
    update: (patch: SettingsPatch) => request.patch<SettingsResponse>("/tenant/settings/update", patch),
    uploadLogo: (file: File) => {
        const fd = new FormData();
        fd.append("company_logo", file);
        return request.post<{ message?: string; companyLogo?: string; settings?: TenantSettings }>(
            "/tenant/settings/logo",
            fd
        );
    },
};
